import styled, { css } from 'styled-components';
import { mediasQuery } from '@utils/responsive';

export const WrapperContent = styled.div`
  ${({ theme }) => css`
    position: relative;
    top: ${theme.spacing.km3};
  `}
`;

export const Page = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.color.background.neutral.default};
    margin: 0 ${theme.spacing.km6};
    position: relative;

    ${mediasQuery.minMdMin} {
      margin: 0 ${theme.spacing.km12};
    }
  `}
`;
